<template>
  <vs-popup
    :active.sync="isOpen"
    button-close-hidden
    fullscreen
    title="DN"
    ref="dialog"
  >
    <div class="flex flex-col" :style="{ minHeight: contentHeight }">
      <!-- <div class="flex flex-row">
        <div
          class="p-4 w-1/2 overflow-y-auto border-r border-l-0 border-t-0 border-b-0 border-solid border-grey-light"
          :style="{ minHeight: rowHeight, maxHeight: rowHeight }"
        >
          <debit-note
            v-if="!isLoading"
            :supplierCode="SupplierCode"
            :supplierID="SupplierID"
            :isOpen="isOpen"
            @resetIsLoading="resetIsLoading"
          />
        </div>
        <div
          class="p-4 w-1/2 overflow-y-auto"
          :style="{ minHeight: rowHeight, maxHeight: rowHeight }"
        >
          <selected-proposals
            :proposal-data="selectedProposal"
            :currencyCode="currencyCode"
            :isOpen="isOpen"
            :unpaidValues="unpaidValues"
          />
        </div>
      </div>
      <vs-divider />
      <div class="flex flex-row justify-between w-full gap-4">
        <total-info
          :title="'Total Paid Now Selected Proposal'"
          :value="
            priceFormatWithMinus(
              this.$store.state.clearingDN.totalSelectedPaidNows,
              !currencyCode ? '' : currencyCode
            )
          "
        />
        <total-info
          :title="'Total Selected DN'"
          :value="
            priceFormatWithMinus(
              this.$store.state.clearingDN.totalSelectedDebitNotesValue,
              !currencyCode ? '' : currencyCode
            )
          "
        />
        <total-info
          :title="'Total Proposal - Total DN'"
          :value="calculateProposalMinusDN(!currencyCode ? '' : currencyCode)"
        />
      </div>
      <div class="flex flex-row justify-end gap-4">
        <vs-button class="sticky" color="danger" @click="closeModal(false)"
          >Cancel</vs-button
        >
        <vs-button class="sticky" @click="nextTab()">Clearing</vs-button>
      </div> -->
      <vs-tabs :value="currentTab">
        <vs-tab label="Clearing">
          <div class="flex flex-row">
            <div
              class="p-4 w-1/2 overflow-y-auto border-r border-l-0 border-t-0 border-b-0 border-solid border-grey-light"
              :style="{ minHeight: rowHeight, maxHeight: rowHeight }"
            >
              <debit-note
                v-if="!isLoading"
                :supplierCode="SupplierCode"
                :supplierID="SupplierID"
                :isOpen="isOpen"
                :poType="poType"
                @resetIsLoading="resetIsLoading"
              />
            </div>
            <div
              class="p-4 w-1/2 overflow-y-auto"
              :style="{ minHeight: rowHeight, maxHeight: rowHeight }"
            >
              <selected-proposals
                :proposal-data="selectedProposal"
                :currencyCode="currencyCode"
                :isOpen="isOpen"
                :unpaidValues="unpaidValues"
                :poType="poType"
              />
            </div>
          </div>
          <vs-divider />
          <div class="flex flex-row justify-between w-full gap-4">
            <total-info
              :title="'Total Paid Now Selected Proposal'"
              :value="
                priceFormatWithMinus(
                  this.$store.state.clearingDN.totalSelectedPaidNows,
                  !currencyCode ? '' : currencyCode
                )
              "
            />
            <total-info
              :title="'Total Selected DN'"
              :value="
                priceFormatWithMinus(
                  this.$store.state.clearingDN.totalSelectedDebitNotesValue,
                  !currencyCode ? '' : currencyCode
                )
              "
            />
            <total-info
              :title="'Total Proposal - Total DN'"
              :value="
                calculateProposalMinusDN(!currencyCode ? '' : currencyCode)
              "
            />
          </div>
          <div class="flex flex-row justify-end gap-4">
            <vs-button class="sticky" color="danger" @click="closeModal(false)"
              >Cancel</vs-button
            >
            <vs-button class="sticky" @click="nextTab()">Clearing</vs-button>
          </div>
        </vs-tab>
        <vs-tab label="Schema"
          ><clearing-schema
            :currentTab="currentTab"
            @backTab="backTab"
            @clearing="handleClearing"
            :selectedProposal="selectedProposal"
            :poType="poType"
        /></vs-tab>
      </vs-tabs>
    </div>
  </vs-popup>
</template>

<style scoped></style>

<script>
import DebitNote from "./debit-note.vue";
import selectedProposal from "./selected-proposal.vue";
import TotalInfo from "./totalInfo.vue";
import moment, { duration } from "moment";
import clearingSchema from "./clearing-schema.vue";

export default {
  mounted() {
    this.contentHeight = `calc(${window.innerHeight}px - 80px)`;
    this.rowHeight = `calc(${window.innerHeight}px - 280px)`;
  },
  created() {
    this.$store.watch(
      (state) => state.clearingDN.debitNotePaidValues,
      (newValue) => {
        const temp = [...newValue];
        let total = temp.reduce((acc, curr) => {
          const remaining = curr.clearing_value;
          return acc + remaining;
        }, 0);

        this.$store.commit("clearingDN/setTotalSelectedDebitNotesValue", total);
      }
    );

    this.$store.watch(
      (state) => state.clearingDN.proposalPaidNows,
      (newValue) => {
        const temp = [...newValue];
        const temp2 = [...this.$store.state.clearingDN.selectedDebitNotes];

        const total = temp.reduce((acc, curr) => {
          return acc + curr.value;
        }, 0);
        this.$store.commit("clearingDN/setTotalSelectedPaidNows", total);

        if (temp.length <= this.selectedProposal.length) {
          if (temp.length === this.selectedProposal.length) {
            this.isInitialized = true;
          }
          return;
        }

        if (!this.isInitialized) {
          return;
        }

        let total2 = temp2.reduce((acc, curr) => {
          const remaining = curr.value;
          return acc + remaining;
        }, 0);

        if (total2 > total) {
          total2 = total;
        }
        this.$store.commit("clearingDN/setTotalSelectedDebitNotesValue", total);
      }
    );
  },
  components: {
    "selected-proposals": selectedProposal,
    "debit-note": DebitNote,
    "total-info": TotalInfo,
    "clearing-schema": clearingSchema,
  },
  props: {
    isOpen: Boolean,
    selectedProposal: Array,
    poType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      contentHeight: "",
      rowHeight: "",
      isInitialized: false,
      isLoading: true,
      currencyCode: "",
      SupplierCode: "",
      SupplierID: 0,
      unpaidValues: [],
      currentTab: 0,
      isClearingDisabled: false,
      activeTab: 0,
    };
  },
  methods: {
    closeModal(isReload) {
      // this.isOpen = false;
      if (isReload) {
        this.$emit("closeModalWithReload", false);
      } else {
        this.$emit("closeModal", false);
      }
      this.clearState();
    },
    calculateProposalMinusDN(currencyCode) {
      let dif =
        this.$store.state.clearingDN.totalSelectedPaidNows -
        this.$store.state.clearingDN.totalSelectedDebitNotesValue;

      // if (dif < 0) {
      //   // dif = 0;
      // }

      this.$store.commit("clearingDN/setTotalDebitNotesMinusPaidNows", dif);
      console.log( this.$store.state.clearingDN.totalDebitNotesMinusPaidNows)
      return this.priceFormatWithMinus(
        this.$store.state.clearingDN.totalDebitNotesMinusPaidNows,
        currencyCode
      );
    },
    priceFormatWithMinus(amount, currencyCode) {
      const newAmount = amount
        .toString()
        .replace(/[^.\d-]/g, "")
        .toString();
  
      amount = parseFloat(newAmount).toFixed(2);

      return `${amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} (${currencyCode})`;
    },
    async updatePriceValue(newValue, id) {
      const data = {
        id,
        paid_value: newValue,
      };
      return this.$http.put(
        "/api/v1/purchase-payment-proposal/paid-value",
        data
      );
    },
    async deletePurchasePaymentProposal(id) {
      return this.$http.delete(`/api/v1/purchase-payment-proposal/${id}`);
    },
    async postPurchasePaymentRequest(id) {
      const data = { proposal_id: [id] };
      return this.$http.post("/api/v1/purchase-payment-request/generate", data);
    },
    getProposalInfo(id) {
      return this.$http.get("/api/v1/purchase-payment-proposal/line/" + id);
    },
    getCreditNoteSupplierDetail(id) {
      return this.$http.get(
        `/api/v1/credit-note-supplier/line-for-proposal/${id}`
      );
    },
    async get(id) {
      try {
        this.$vs.loading();
        const resp = await this.getProposalInfo(id);
        if (resp.code < 299) {
          this.currencyCode =
            this.poType !== "CN Supplier"
              ? resp.data.purchaseInvoice.CurrencyCode
              : "IDR";
          this.SupplierCode =
            this.poType !== "CN Supplier"
              ? resp.data.purchaseInvoice.SupplierCode
              : resp.data.creditNoteSupplier.supplier_code;
          this.SupplierID =
            this.poType !== "CN Supplier"
              ? resp.data.purchaseInvoice.SupplierID
              : resp.data.creditNoteSupplier.supplier_id;
          console.log("supplier id", this.SupplierID);

          const unpaidValue = {
            id: id,
            value: resp.data.unpaid_value,
            remaining_value: resp.data.unpaid_value,
          };

          if (this.poType !== "CN Supplier") {
            unpaidValue.purchase_invoice_id = resp.data.purchaseInvoice.ID;
          } else {
            unpaidValue.credit_note_supplier_id =
              resp.data.creditNoteSupplier.ID;
          }

          this.unpaidValues.push(unpaidValue);
        } else {
          throw new Error(resp.message);
        }

        console.log("unpaid values", this.unpaidValues);

        this.$vs.loading.close();
        this.isLoading = false;
      } catch (e) {
        this.$vs.loading.close();
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleClearing(schemas) {
      console.log("handle clearing", schemas);
      try {
        let selectedDN = JSON.parse(
          JSON.stringify(this.$store.state.clearingDN.debitNotePaidValues)
        );

        if (selectedDN.length === 0) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Clearing",
            text: "Please select at least one debit note",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          return;
        }

        selectedDN.sort((a, b) => a.clearing_value - b.clearing_value);
        console.log("selected DN", selectedDN);

        const selectedProposalPaidNow = JSON.parse(
          JSON.stringify(this.$store.state.clearingDN.proposalPaidNows)
        );

        selectedProposalPaidNow.sort(
          (a, b) => a.remaining_value - b.remaining_value
        );

        if (
          !selectedProposalPaidNow.every(
            (item) => item.value <= item.remaining_value
          )
        ) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Clearing",
            text: "Paid now cannot be more than purchase payment proposal value",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          return;
        }

        // selectedProposalPaidNow.sort(
        //   (a, b) => a.remaining_value - b.remaining_value
        // );

        this.$vs.loading();

        console.log("selected proposal", selectedProposalPaidNow);

        let debit_notes = selectedDN.map((dn) => ({
          id: dn.id,
          clearing_value: dn.clearing_value,
        }));
        const body = {
          debit_notes,
          posting_date: moment().format("YYYY-MM-DD"),
          description: "apply dn",
          po_type: this.poType,
          schemas,
        };

        if (this.poType !== "CN Supplier") {
          body.invoices = selectedProposalPaidNow.map((proposalPaidNow) => {
            const proposal = this.selectedProposal.find(
              (item) => item.ID === proposalPaidNow.id
            );
            // this.selectedProposal
            console.log("proposal paid now", proposalPaidNow);

            return {
              paid_value: proposalPaidNow.value,
              purchase_payment_proposal_id: proposal.ID,
              purchase_invoice_code_internal:
                proposal.PurchaseInvoiceCodeInternal,
              purchase_invoice_code: proposal.PurchaseInvoiceCode,
              purchase_invoice_id: proposal.PurchaseInvoiceID,
            };
          });
        } else {
          body.credit_note_suppliers = selectedProposalPaidNow.map(
            (proposalPaidNow) => {
              const proposal = this.selectedProposal.find(
                (item) => item.ID === proposalPaidNow.id
              );
              // this.selectedProposal
              console.log("proposal paid now", proposalPaidNow);

              return {
                paid_value: proposalPaidNow.value,
                purchase_payment_proposal_id: proposal.ID,
                credit_note_supplier_id: proposal.CreditNoteSupplierID,
              };
            }
          );
        }

        const url =
          this.poType !== "CN Supplier"
            ? "/api/v1/debit-note/purchase-payment/purchase-invoice"
            : "/api/v1/debit-note/purchase-payment/cn-supplier";
        const resp = await this.$http.post(url, body);

        if (resp.code <= 299) {
          this.$vs.loading.close();
          this.closeModal(true);
          this.$vs.notify({
            title: "Clearing",
            text: "clearing success",
            color: "success",
            position: "top-right",
            iconPack: "feather",
          });
        } else {
          this.$vs.loading.close();
          throw new Error(resp.message);
        }
      } catch (e) {
        this.$vs.loading.close();
        console.log(e);
        this.$vs.notify({
          title: "Clearing",
          text: e.message,
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
    async postClearing2() {
      try {
        this.$vs.loading();

        const selectedDN = JSON.parse(
          JSON.stringify(this.$store.state.clearingDN.selectedDebitNotes)
        );
        const selectedProposalPaidNow = JSON.parse(
          JSON.stringify(this.$store.state.clearingDN.proposalPaidNows)
        );

        console.log("selected proposal", selectedProposalPaidNow);

        let isNotFullyPaid = false;
        let dnIndex = 0;
        for (let i = 0; i < selectedProposalPaidNow.length; i++) {
          for (let y = dnIndex; y < selectedDN.length; y++) {
            if (selectedDN[y].value === 0) {
              continue;
            }
            let dnValue = selectedDN[y].value;
            let paid_now;
            //check weather the dn value is enough to pay the proposal
            if (dnValue - selectedProposalPaidNow[i].value < 0) {
              //if not enough, then the paid now value is the dn value
              paid_now = dnValue.toFixed(2);
              selectedDN[y].value = 0;
              selectedProposalPaidNow[i].value =
                selectedProposalPaidNow[i].value - dnValue;
            } else {
              //if enough, then the paid now value is the proposal value
              paid_now = selectedProposalPaidNow[i].value.toFixed(2);
              selectedDN[y].value -= selectedProposalPaidNow[i].value;
              selectedProposalPaidNow[i].value = 0;
            }
            const body = {
              debit_note_id: selectedDN[y].id,
              debit_note_code: selectedDN[y].code,
              posting_date: moment().format("YYYY-MM-DD"),
              description: "",
              notes: "-",
              type: 2,
              // invoice: this.selectedProposal.map((proposal) => ({
              //   ...proposal,
              //   paid_now,
              // })),
              invoice: [
                {
                  ...this.selectedProposal[i],
                  paid_now,
                },
              ],
            };
            // console.log(body);
            let resp = await this.$http.post(
              "/api/v1/debit-note/apply-to-invoice",
              body
            );
            let isSuccess = resp.code.toString().startsWith("2");
            if (!isSuccess) {
              this.$vs.loading.close();
              throw new Error(resp.message);
            }
            //check weather the proposal is fully paid
            if (selectedProposalPaidNow[i].value === 0) {
              //if fully paid, then delete the proposal
              resp = await this.deletePurchasePaymentProposal(
                selectedProposalPaidNow[i].id
              );
              isSuccess = resp.code.toString().startsWith("2");
              if (!isSuccess) {
                this.$vs.loading.close();
                throw new Error(resp.message);
              }
              break;
            } else if (
              //if not fully paid and it is the last DN, then update the 'isnotfullypaid' flag to true
              y === selectedDN.length - 1 &&
              selectedProposalPaidNow[i].value > 0
            ) {
              isNotFullyPaid = true;
              break;
            }
          }
          if (isNotFullyPaid) {
            const value = selectedProposalPaidNow[i].value.toFixed(2);
            const resp = await this.updatePriceValue(
              parseFloat(value),
              selectedProposalPaidNow[i].id
            );
            if (!resp.code.toString().startsWith("2")) {
              throw new Error(resp.message);
            }
            const resp2 = await this.postPurchasePaymentRequest(
              selectedProposalPaidNow[i].id
            );
            if (!resp2.code.toString().startsWith("2")) {
              throw new Error(resp.message);
            }
            isNotFullyPaid = false;
          }
          // if (!selectedDN.some((dn) => dn.value > 0)) {
          //   break;
          // }
          dnIndex = selectedDN.findIndex((dn) => dn.value > 0);
          if (dnIndex === -1) {
            break;
          }
        }

        this.$vs.loading.close();
        this.closeModal(true);
        this.$vs.notify({
          title: "Clearing",
          text: "clearing success",
          color: "success",
          position: "top-right",
          iconPack: "feather",
        });
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: "Clearing",
          text: e.message,
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
    async postClearing() {
      try {
        this.$vs.loading();
        console.log("postClearing");
        //copy the state useing JSON method. this ensure that the state is deeply copied
        const selectedDN = this.$store.state.clearingDN.selectedDebitNotes;
        const selectedProposalPaidNow = JSON.parse(
          JSON.stringify(this.$store.state.clearingDN.proposalPaidNows)
        );
        let startProposalIndex = 0;
        let indexBuff = 0;
        for (const dn of selectedDN) {
          let dnValue = dn.dn_value - dn.used_dn_value;
          console.log("dn value", dnValue);
          let isdnValueZero = false;
          for (
            let index = startProposalIndex;
            index < selectedProposalPaidNow.length;
            index++
          ) {
            indexBuff = index;
            const proposalPaidNowValue = selectedProposalPaidNow[index].value;
            let paid_now;
            if (dnValue - proposalPaidNowValue < 0) {
              paid_now = dnValue.toFixed(2);
              selectedProposalPaidNow[index].value =
                proposalPaidNowValue - dnValue;
              isdnValueZero = true;
            } else {
              paid_now = proposalPaidNowValue.toFixed(2);
              selectedProposalPaidNow[index].value = 0;
            }
            const body = {
              debit_note_id: dn.dn_id,
              debit_note_code: dn.dn_code,
              posting_date: moment().format("YYYY-MM-DD"),
              description: "",
              notes: "-",
              type: 2,
              invoice: this.selectedProposal.map((proposal) => ({
                ...proposal,
                paid_now,
              })),
            };
            console.log(body);
            let resp = await this.$http.post(
              "/api/v1/debit-note/apply-to-invoice",
              body
            );
            let isSuccess = resp.code.toString().startsWith("2");
            if (!isSuccess) {
              this.$vs.loading.close();
              throw new Error(resp.message);
            }

            if (isdnValueZero) {
              startProposalIndex = indexBuff;
              break;
            }

            resp = await this.deletePurchasePaymentProposal(
              selectedProposalPaidNow[index].id
            );
            isSuccess = resp.code.toString().startsWith("2");
            if (!isSuccess) {
              this.$vs.loading.close();
              throw new Error(resp.message);
            }

            dnValue -= proposalPaidNowValue;
          }
          //check weather the invoice value is all zero
          if (!selectedProposalPaidNow.some((item) => item.value > 0)) {
            //value is all zero, then break the DN loop
            break;
          }
          console.log("clearing success");
        }
        const proposalWithRemaingPaidNow = selectedProposalPaidNow.find(
          (item) => item.value > 0
        );

        if (proposalWithRemaingPaidNow !== undefined) {
          console.log("still have remaining paid now");
          try {
            const resp = await this.updatePriceValue(
              proposalWithRemaingPaidNow.value,
              proposalWithRemaingPaidNow.id
            );
            if (!resp.code.toString().startsWith("2")) {
              throw new Error(resp.message);
            }
            const resp2 = await this.postPurchasePaymentRequest(
              proposalWithRemaingPaidNow.id
            );
            if (!resp2.code.toString().startsWith("2")) {
              throw new Error(resp.message);
            }
          } catch (e) {
            throw new Error(e.message);
          }
        }
        this.$vs.loading.close();
        this.closeModal(true);
        this.$vs.notify({
          title: "Clearing",
          text: "clearing success",
          color: "success",
          position: "top-right",
          iconPack: "feather",
        });
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: "Clearing",
          text: e.message,
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },

    resetIsLoading() {
      this.isLoading = true;
    },
    nextTab() {
      let selectedDN = JSON.parse(
        JSON.stringify(this.$store.state.clearingDN.selectedDebitNotes)
      );

      if (selectedDN.length === 0) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Clearing",
          text: "Please select at least one debit note",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return;
      }

      let dnForClearingData = JSON.parse(
        JSON.stringify(this.$store.state.clearingDN.debitNotePaidValues)
      );

      if (dnForClearingData.length === 0) {
        this.$vs.notify({
          title: "Clearing",
          text: "Please select at least one debit note",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        throw new Error("Please select at least one debit note");
      }

      if ( this.$store.state.clearingDN.totalDebitNotesMinusPaidNows < 0) {
        this.$vs.notify({
          title: "Clearing",
          text: "Total Proposal - Total DN must be greater or equal 0",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        throw new Error("Total Proposal - Total DN must be greater or equal 0");
      }
      for (let i = 0; i < dnForClearingData.length; i++) {
        if (dnForClearingData[i].clearing_value === 0) {
          this.$vs.notify({
            title: "Clearing",
            text: `Value for debit note ${dnForClearingData[i].code} cannot be 0`,
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
            time: 4000,
          });
          throw new Error("Paid value cannot be 0");
        }

        if (
          dnForClearingData[i].clearing_value >
          dnForClearingData[i].remaining_value
        ) {
          this.$vs.notify({
            title: "Clearing",
            text: `Value for debit note ${
              dnForClearingData[i].code
            } cannot be more than ${this.priceFormat(
              dnForClearingData[i].remaining_value
            )}`,
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
            time: 4000,
          });
          throw new Error("Paid value cannot be more than remaining value");
        }
      }

      // selectedDN.sort((a, b) => a.value - b.value);
      console.log("selected DN", selectedDN);

      const selectedProposalPaidNow = JSON.parse(
        JSON.stringify(this.$store.state.clearingDN.proposalPaidNows)
      );

      if (
        !selectedProposalPaidNow.every(
          (item) => item.value <= item.remaining_value
        )
      ) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Clearing",
          text: "Paid now cannot be more than purchase payment proposal value",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return;
      }
      this.currentTab = 1;
    },
    backTab() {
      this.currentTab = 0;
    },
    disableTabThumb() {
      const elements = document.getElementsByClassName("vs-tabs--li");
      elements.forEach((element) => {
        element.style.pointerEvents = "none";
      });
    },
    enableTabThumb() {
      const elements = document.getElementsByClassName("vs-tabs--li");
      elements.forEach((element) => {
        element.style.pointerEvents = "auto";
      });
    },
    clearState() {
      this.enableTabThumb();
      this.$store.commit("clearingDN/clearState");
      this.unpaidValues = [];
      this.supplierID = 0;
      this.supplierCode = "";
      this.currentTab = 0;
      this.isLoading = true;
    },
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.disableTabThumb();
        for (const proposal of this.selectedProposal) {
          this.get(proposal.ID);
        }
        console.log("proposal", this.selectedProposal);
        console.log("po type", this.poType);
      } else {
        this.clearState();
      }
    },
  },
};
</script>

<style>
.vs-popup--header {
  display: none !important;
}

.vs-popup--content {
  max-height: none !important;
  min-height: 100% !important;
}
</style>
